import { IEmailTemplate, IEmailTemplateSettings } from '@core/types'
import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty, IsNotEmptyObject, IsString, ValidateNested } from 'class-validator'

export class EmailTemplate implements IEmailTemplate {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	templateId: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	title: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	description: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	previewImageUrl: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	subject: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	body: string
}

export class EmailTemplateSettings implements IEmailTemplateSettings {
	@ApiProperty({ type: EmailTemplate })
	@IsNotEmptyObject()
	@ValidateNested()
	reservationConfirmed: EmailTemplate

	@ApiProperty({ type: EmailTemplate })
	@IsNotEmptyObject()
	@ValidateNested()
	reservationReminder: EmailTemplate
}
